import { Component } from '@theme/component';

/**
 * Selector de packs (1/3/6 unidades) para un producto puntual.
 *
 * No reimplementa nada del carrito: al elegir un pack, sincroniza el
 * `quantity-selector-component` real (oculto en el DOM, dentro del mismo
 * `<form>`) para que el submit de "Comprar ahora" siga su camino normal
 * -stock, variantes, carrito AJAX, analytics- sin ningún cambio.
 *
 * @extends {Component}
 */
class ProductPackSelector extends Component {
  connectedCallback() {
    super.connectedCallback();

    // The hidden real quantity input always starts at its own server-rendered
    // default (usually 1), independent of which pack card is marked
    // `checked` in Liquid. Sync it once on load so "Comprar ahora" adds the
    // right amount even if the shopper never touches a card.
    const checkedInput = this.querySelector('input[name="pack-option"]:checked');
    if (checkedInput instanceof HTMLInputElement) {
      this.#applyQuantity(checkedInput.value);
    }
  }

  /**
   * @param {Event} event
   */
  handlePackChange(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'pack-option') return;

    this.#applyQuantity(input.value);
  }

  /**
   * @param {string} value
   */
  #applyQuantity(value) {
    const quantity = Number(value);
    if (!Number.isFinite(quantity) || quantity < 1) return;

    const form = this.closest('form');
    const quantitySelector = form?.querySelector('quantity-selector-component');
    if (!quantitySelector) return;

    quantitySelector.setValue?.(quantity.toString());
    quantitySelector.onQuantityChange?.();
    quantitySelector.updateButtonStates?.();
  }
}

if (!customElements.get('product-pack-selector')) {
  customElements.define('product-pack-selector', ProductPackSelector);
}
